import {AxiosResponse} from "axios"
import RequestHelper, {ActionAnswer, CommandData} from "../utils/RequestsHelper"

interface AppSettings {
    config: { apiKey: string, clientId: string, host: string },
    heartbeatCommand: string
    logging: boolean
}

export default class AppSettingsApi {
    public static getAuthConfig(): Promise<AxiosResponse<ActionAnswer<AppSettings>>> {
        return RequestHelper.send("get", "auth")
    }

    public static setAuthConfig(apiKey: string, clientId: string): Promise<AxiosResponse<ActionAnswer>> {
        return RequestHelper.send("post", "auth", {
            apiKey, clientId
        })
    }

    public static setLogging(value: boolean): Promise<AxiosResponse<ActionAnswer>> {
        return RequestHelper.send("post", "auth&action=isLogging", {
            value
        })
    }
}